import React, {Component} from 'react';
import Modal from 'react-modal';
import classes from './ErrorMsg.css';
import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';

export class ErrorMsg extends Component {
    render() {
        return (
            <Modal
                isOpen={this.props.hasError}
            >
                <div className={classes.ErrorMsg}>{this.props.msg}</div>
                <div className={classes.buttonContainer}>
                    <button className={classes.okButton} onClick={this.props.clearError}>OK</button>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        hasError: state.globalState.errorState.hasError,
        msg: state.globalState.errorState.errorMessage
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearError: () => dispatch({type: actionTypes.CLEAR_ERROR_STATE})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorMsg);


// WEBPACK FOOTER //
// ./src/containers/ErrorMsg/ErrorMsg.js